<div class="border border-2 px-4 py-3 rounded-4 my-2 card bg-white">
    <div class="mb-3">
        <div class="card-body d-flex justify-content-between align-items-center">
            <div class="fw-bold h4 lvl-1 mb-0">Subtotal*</div>
            <div class="mb-0">
                <span class="h3 lvl-1 fw-bold m-0">{{ summary.subTotal | currency:'USD':'symbol':'1.2-2' }}</span>
                <span class="caption m-0 ms-1">{{ summary.priceSuffix | paymentSuffix }}</span>
            </div>
        </div>

        <div class="card-body d-flex justify-content-between align-items-center" *ngIf="summary.discount">
            <div class="fw-bold h4 lvl-1 mb-0">Discount</div>
            <div class="mb-0">
                <span class="h3 lvl-1 fw-bold text-danger m-0">- {{ summary.discount | currency:'USD':'symbol':'1.2-2' }}</span>
                <span class="caption m-0">{{ summary.priceSuffix | paymentSuffix }}</span>
            </div>
        </div>

        <div class="card-body d-flex justify-content-between align-items-center" *ngIf="summary.subTotalAfterDiscount && summary.discount">
            <div class="fw-bold h4 lvl-1 mb-0">Subtotal after discount</div>
            <div class="mb-0">
                <span class="h3 lvl-1 fw-bold m-0">{{ summary.subTotalAfterDiscount | currency:'USD':'symbol':'1.2-2' }}</span>
                <span class="caption m-0">{{ summary.priceSuffix | paymentSuffix }}</span>
            </div>
        </div>
    </div>

    <div class="mb-2">
        <div class="card-body d-flex justify-content-between align-items-center">
            <div class="fw-bold h4 lvl-1 mb-0">Tax</div>
            <div class="mb-0">
                <span class="h3 lvl-1 fw-bold m-0">{{ summary.tax | currency:'USD':'symbol':'1.2-2' }}</span>
                <span class="caption m-0">{{ summary.priceSuffix | paymentSuffix }}</span>
            </div>
        </div>

        <div class="card-body d-flex justify-content-between align-items-center" *ngIf="summary.luxuryTax" >
            <div class="fw-bold h4 lvl-1 mb-0">Luxury Tax</div>
            <div class="mb-0">
                <span class="h3 lvl-1 fw-bold m-0">{{ summary.luxuryTax | currency:'USD':'symbol':'1.2-2' }}</span>
                <span class="caption m-0">{{ summary.priceSuffix | paymentSuffix }}</span>
            </div>
        </div>
    </div>

    <div class="mt-2">
        <div class="card-body d-flex justify-content-between align-items-center">
            <div class="fw-bold h4 mb-0">Total</div>
            <div class="mb-0">
                <span class="h3 fw-bold m-0">{{ summary.total | currency:'USD':'symbol':'1.2-2' }}</span>
                <span class="caption m-0">{{ summary.priceSuffix | paymentSuffix }}</span>
            </div>
        </div>
    </div>
</div>

<div class="cost-of-borrow m-0 pt-1 lvl-1 pb-0" *ngIf="summary.costOfBorrowing">
    *Total Cost of Borrowing:
    {{ summary.costOfBorrowing }}
</div>

<div class="cost-of-borrow m-0 lvl-1 pb-2">
    *Not Including Installation
</div>
